import { ref } from 'vue';

export class CountingLoader {
  #count = 0;
  #isManuallySwitched = false;

  public isLoading = ref<boolean>(false);

  public inc() {
    this.#count++;
    this.#isManuallySwitched = false;
    this.isLoading.value = true;
  }

  public dec() {
    this.#count = Math.max(0, this.#count - 1);
    this.isLoading.value = !!this.#count || this.#isManuallySwitched;
  }

  public switchOn() {
    this.isLoading.value = true;
    this.#isManuallySwitched = true;
  }

  public switchOff() {
    this.isLoading.value = !!this.#count;
    this.#isManuallySwitched = false;
  }
}
